<template>
    <div class="bottom-nav" v-bind:class="{'hide': !this.showBottomNav}">
        <div class="container">
            <div class="bottom-nav__left" v-if="!this.$store.getters.isMobile">
                <img @click="resetToHome" src="/logo@2x.png" alt="Cerner" class="logo">
                <span v-html="$route.meta.title"></span>
            </div>

            <div class="bottom-nav__center" v-bind:class="{ 'mobile': this.$store.getters.isMobile, 'dashboard': this.$store.getters.isPortal }">

                <template v-if="action == 'button'">

                    <template v-if="this.hasSelectedDrivers">
                        <router-link :to="link" class="button">Next</router-link>
                    </template>
                    <template v-else>
                        <span class="button is-disabled" @click="alert">Next</span>
                    </template>
                </template>

                <template v-if="action == 'steps'">
                    <ul>
                        <li v-for="(stack, index) in stacks" :class="getClass(stack)"><svg class="icon" :class="'icon-'+stack.category+'-circle'"><use v-bind="{'xlink:href':'#icon-'+stack.category+'-circle'}"></use></svg></li>
                    </ul>
                </template>

                <template v-if="action == 'method'">
                    <button @click="submit" class="button is-blue">Submit</button>
                </template>

                <template v-if="this.isPortal">
                    <span v-if="this.isMobile">
                        <div class="dashboard-mobile-bottom-nav" v-if="!this.$store.getters.isMobileDashboardOpen" @click="toggleDashboard">
                            <h2>User Dashboard</h2>
                            <img class="up" src="./../../img/chevron-down.svg">
                        </div>
                        <div class="dashboard-mobile-bottom-nav" v-if="this.$store.getters.isMobileDashboardOpen" @click="toggleDashboard">
                            <h2>Close User Dashboard</h2>
                            <img src="./../../img/chevron-down.svg">
                        </div>
                    </span>
                </template>

            </div>

            <div class="bottom-nav__right" v-if="!this.$store.getters.isMobile">
                <a href="#" v-if="1 === 2"><svg class="icon icon-Info"><use xlink:href="#icon-Info"></use></svg> Help + Information</a>
                <a v-if="$route.path == '/portal'" href="/share"><svg class="icon icon-Share"><use xlink:href="#icon-Share"></use></svg> Share Portal</a>
                <a v-if="$route.path == '/share'" href="/portal"><svg class="icon icon-Grid"><use xlink:href="#icon-Grid"></use></svg> Dashboard</a>
                <a v-if="$route.path != '/portal' && $route.path != '/share'" href="/custom-dashboard" @click="reset"><svg class="icon icon-Refresh"><use xlink:href="#icon-Refresh"></use></svg> Start Over</a>
                <a href="/" @click="reset"><svg class="icon icon-Exit"><use xlink:href="#icon-Exit"></use></svg> Exit Portal</a>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../router.js';
    import EventBus from '../eventbus.js';

    export default {
        data : function() {
            return {
                title: this.$route.meta.title,
                action: null,
                link: null,
                stacks: null,
                hasSelectedDrivers: true,
                isPortal: false,
                isMobile: false,
                isSharePage: false,
                showBottomNav: true
            }
        },
        computed: {
            category() {
                return this.$store.getters.category;
            },
            selectedDrivers() {
                let drivers = this.$store.getters.drivers;

                for (var i = 0; i < drivers.length; i++) {
                    if ( drivers[i].selected ) {
                        return true;
                    }
                }

                return false;
            }
        },
        created() {
            EventBus.$on( 'nav.updateAction', (action) => {
                this.updateAction(action);
            });
            EventBus.$on( 'nav.updateStacks', (stacks) => {
                this.updateStacks(stacks);
            });
            EventBus.$on( 'nav.updateLink', (link) => {
                this.updateLink(link);
            });

            EventBus.$on('shareView', (value) => {
                this.isSharePage = value;
            });

            this.checkPortalFilter();

            EventBus.$on('resize', () => {
                this.checkPortalFilter();
            });

            // $store runs before here but isPortal is false here
            this.$store.commit('updateIsPortal', window.location.href.indexOf('/portal') !== -1 ? true : false);
        },
        mounted() {
            EventBus.$on('updateBottomNav', () => {
                this.isPortal = false;
                this.isMobile = false;

                if ( window.location.href.indexOf('/portal') !== -1 ) {
                    this.isPortal = true;
                }

                if ( window.innerWidth < 1200 ) {
                    this.isMobile = true;
                }
            });
        },
        methods : {
            checkPortalFilter() {
                if ( window.location.href.indexOf('/portal') !== -1 ) {
                    this.isPortal = true;
                    this.hasSelectedDrivers = false;

                    const selDrivers = this.$store.getters.drivers.filter( function(driver) {
                        return driver.selected;
                    });

                    if ( window.innerWidth < 1200 ) {
                        this.isMobile = true;
                    } else {
                        this.isMobile = false;
                    }

                    if ( selDrivers.length ) {
                        this.hasSelectedDrivers = true;
                    } else {
                        if ( this.isMobile ) {
                            this.showBottomNav = false;
                        } else {
                            this.showBottomNav = true;
                        }
                    }
                }
            },
            updateAction(action) {
                this.action = action;
            },
            updateStacks(stacks) {
                this.stacks = stacks;
            },
            updateLink(link) {
                this.link = link;
            },
            getClass(stack) {
                if ( stack.active && !stack.complete ) {
                    return 'active';
                } else if ( !stack.active && !stack.complete ) {
                    return 'inactive'
                } else if ( stack.complete ) {
                    return 'complete';
                }
            },
            alert() {
                alert('Please select at least one value driver');
            },
            next() {
                EventBus.$emit('shareEmail', true);
            },
            reset(event) {
                sessionStorage.clear();
            },
            resetToHome() {
                sessionStorage.clear();
                router.push('/');
            },
            sharePopup() {
                EventBus.$emit('sharePopup', true);
            },
            toggleDashboard() {
                this.$store.commit('updateIsMobileDashboardOpen', !this.$store.getters.isMobileDashboardOpen);
                EventBus.$emit('dashboardToggle');

                if ( this.$store.getters.isMobileDashboardOpen ) {
                    $('body').addClass('locked');
                } else {
                    setTimeout( function() {
                        $('body').removeClass('locked'); // wait for animation to finish due to double scrollbars
                    }, 300);
                }
            },
            saveDashboard() {
                if ( !this.$store.getters.emails ) {
                    alert('Please enter at least one email');
                    return;
                }

                axios.post('/api/v1/save-dashboard', {
                    filters: this.$store.getters.activeFilters,
                    drivers: this.$store.getters.drivers
                })
                .then( ( response ) => {
                    alert('Your custom dashboard has been saved and a link will be sent to the email(s) provided.');
                    const key = response.data.key;

                    axios.post('/api/v1/share',{
                        emails: this.$store.getters.emails,
                        url: window.location.protocol + "//" + window.location.host + '/portal?custom_dashboard=' + key,
                    })
                    .then( ( response ) => {
                        this.$store.commit('updateEmailList', ''); // empty email list
                        EventBus.$emit('setActiveDashboardKey', key);
                    })
                    .catch( function( error ) {
                        console.log( error );
                    });

                    router.push('/portal');
                })
                .catch( function( error ) {
                    alert('We are unable to save your dashboard at this time.');
                });
            },
            submit() {
                this.saveDashboard();
            }
        },
        components: {
        },
    }
</script>

<style scoped>
    .bottom-nav.hide {
        display: none;
    }

    .bottom-nav__left .logo {
        cursor: pointer;
    }

    @media screen and (max-width: 1024px) {
        .bottom-nav__left span {
            display: none;
        }

        .bottom-nav__right a:not(:first-of-type) {
            margin-left: 0.5em;
        }

        .bottom-nav .container {
            padding-left: 1em;
            padding-right: 1em;
            max-width: 100%;
            width: 100%;
        }
    }

    .bottom-nav__center.dashboard {
        width: 100%;
        top: initial;
        left: 0;
        transform: none;
        cursor: pointer;
        text-align: center;
    }

    .bottom-nav__center.dashboard .dashboard-mobile-bottom-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: calc(100% - 16px);
    }

    .dashboard-mobile-bottom-nav img.up {
        transform: rotate(180deg);
    }

    .dashboard-mobile-bottom-nav h2 {
        padding-left: 16px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/BottomNav.vue